<template>
    <div class="page-content w-full h-screen flex flex-col">
        <div v-if="!isSmallScreen">
            <header class=" fixed sticky top-0 left-0 right-0 h-[60px] bg-gray-700 text-white flex z-10 items-center justify-between p-4 shadow">
                <div class="flex items-center">
                    <img src="@/assets/logo.png" alt="Logo" class="h-8 mr-2" />
                    <span class="text-xl">识心智能</span>
                </div>
                <LoginModule @loginSucc="handleLogin" ref="loginModule" />
            </header>
        </div>
        <div v-else>
            <CommonHeader></CommonHeader>
        </div>
        <div  v-if="!isSmallScreen" class="main-content w-full flex pt-16 mt-16">
            <!--left-->
            <div class="flex flex-col h-full w-1/2">
                <div class="relative overflow-hidden   h-[calc(100vh-80px)] ">
                    <div class="h-full  flex-1  ">
                        <div class=" h-full px-10 ">
                            <div class="flex flex-col gap-4 pr-2 ">
                                <div class="flex flex-col gap-5">
                                    <div class="p-1 ">
                                        <h1 class="text-3xl font-bold ">
                                            {{curCharacter && curCharacter.name}}
                                        </h1>
                                    </div>
                                    <div class="bg-white rounded-xl shadow-sm p-3 border border-gray-100">
                                        <div class="space-y-1">
                                            <div class="flex items-center space-x-3">
                                                <div class="bg-blue-50 p-2 rounded-lg">
                                                    <i class="fas fa-clock text-blue-500"></i>
                                                </div>
                                                <div>
                                                    <span class="text-gray-500 text-lg">AI来访对话时间：</span>
                                                    <span class="text-lg font-bold text-gray-700 ml-2">{{trainInfo.startTime}}</span>
                                                </div>
                                            </div>

                                            <div class="flex items-center space-x-3">
                                                <div class="bg-green-50 p-2 rounded-lg">
                                                    <i class="fas fa-file-alt text-green-500"></i>
                                                </div>
                                                <div>
                                                    <span class="text-gray-500 text-lg">总结生成时间：</span>
                                                    <span class="text-lg font-bold text-gray-700 ml-2">{{trainInfo.summaryTime?trainInfo.summaryTime:"待生成"}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex flex-wrap gap-2">
                                        <template v-if="curCharacter && curCharacter.key_words">
                                            <span v-for="(word, index) in curCharacter.key_words.split(',')"
                                                    :key="index"
                                                    class="px-4 py-2 bg-blue-50 text-blue-600 rounded-full font-medium hover:bg-blue-100 transition-colors duration-200 shadow-sm">
                                                <i class="fas fa-tag text-xs mr-2"></i>
                                                {{word.trim()}}
                                            </span>
                                        </template>
                                    </div>
                                </div>
                                <hr class="v-divider v-theme--light" aria-orientation="horizontal" role="separator" />
                                <div class="overflow-y-auto scrollable p-2">
                                    <!-- 背景信息卡片 -->
                                    <div class="bg-gradient-to-br from-blue-50 via-blue-100 to-white p-6 rounded-2xl shadow-lg border border-blue-100">
                                        <div class="flex items-center mb-4">
                                            <i class="fas fa-info-circle text-blue-500 text-2xl mr-3"></i>
                                            <div class="text-xl font-bold text-gray-800 border-b-2 border-blue-200 pb-1">
                                                背景信息
                                            </div>
                                        </div>
                                        <div class="text-gray-700 p-3 rounded-xl bg-white/80 backdrop-blur-sm shadow-inner">
                                            {{curCharacter && curCharacter.description ? curCharacter.description:""}}
                                        </div>
                                    </div>

                                    <!-- 摘要提示卡片 -->
                                    <!--<div class="mt-6 bg-gradient-to-br from-amber-50 via-amber-100 to-white p-6 rounded-2xl shadow-lg border border-amber-100">
                                    <div class="flex items-center mb-4">
                                        <i class="fas fa-lightbulb text-amber-500 text-2xl mr-3"></i>
                                        <div class="text-xl font-bold text-gray-800 border-b-2 border-amber-200 pb-1">
                                            摘要提示
                                        </div>
                                    </div>
                                    <div class="bg-white/80 backdrop-blur-sm p-4 rounded-xl shadow-inner">
                                        <div class="text-gray-700" v-html="renderedSummaryPrompt">
                                        </div>
                                    </div>
                                </div>-->
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!--right-->
            <div class="flex flex-col  h-[calc(100vh-60px)] w-1/2">
                <div class="w-full">
                    <div class="text-left h-full px-1">
                        <div class="pt-2 text-2xl font-bold text-center text-gray-600">{{trainInfo.tipInfo}}</div>
                        <!-- 切换按钮 -->
                        <div class="pt-4 px-4 mb-8 text-gray-700 font-semibold flex justify-between items-center">
                            <h4 v-if="pageSelect === 0" class="text-2xl" style="color: rgb(76, 207, 44)">训练记录</h4>
                            <h4 v-else class="pt-1 text-2xl text-gray-600" style="color: rgb(76, 207, 44) ">总结</h4>
                            <div class="shadow-inner rounded-lg bg-gray-200 p-1 mx-auto">
                                <div class="flex space-x-2" role="tablist">
                                    <button type="button" class="flex items-center px-6 py-2   text-gray-700 hover:bg-sky-200 rounded-lg"
                                            role="tab"
                                            :class="pageSelect === 0 ? 'bg-white': 'bg-gray-200'"
                                            @click="setActiveTab(0)"
                                            value="result">
                                        <i class="far fa-file-alt" />
                                        <span class="ml-2">训练记录</span>
                                    </button>
                                    <button type="button" class="flex items-center px-6 py-2  text-gray-700  hover:bg-sky-200 rounded-lg" role="tab"
                                            :class="pageSelect === 1 ? 'bg-white' : 'bg-gray-200'"
                                            @click="setActiveTab(1)"
                                            value="transcript">
                                        <i class="fas fa-newspaper"></i>
                                        <span class="ml-2">总结</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="relative overflow-hidden pt-4 h-[calc(100vh-230px)] overflow-y-auto">
                            <div class="flex transition-transform duration-300  " :style="`transform: translateX(-${pageSelect * 100}%)` ">
                                <div class="w-full flex-shrink-0 h-full">
                                    <div class=" p-8 border border-rounded-2xl rounded-2xl shadow-lg  overflow-y-auto  mr-9  w-full">
                                        <div class="flex justify-between">
                                            <span class="text-2xl p-4 font-semibold text-gray-700 border border-rounded-2xl rounded-2xl shadow-lg max-w-max ">训练问答详情</span>
                                            <button @click="ContinueTalk"
                                                    class="continue-chat-btn group relative inline-flex items-center px-6 py-3 text-lg font-medium rounded-xl bg-gradient-to-r from-yellow-400 to-orange-500 text-white shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 overflow-hidden">
                                                <span class="relative z-10 flex items-center">
                                                    <i class="fas fa-comments mr-2"></i>
                                                    继续对话
                                                    <svg class="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-200"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 18 18">
                                                        <path stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                                    </svg>
                                                </span>
                                                <div class="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-200"></div>
                                            </button>
                                        </div>
                                        <div class="w-full">
                                            <div v-for="(item, index) in QALlist" :key="index" class="flex flex-col mt-6 text-sm">
                                                <div class="bg-gray-50 rounded-2xl p-4">
                                                    <div class="font-medium text-blue-600 font-extrabold text-xl text-left mb-3">{{ index + 1 }}</div>

                                                    <div class="font-medium px-6 p-3 flex items-start gap-4 bg-gradient-to-r from-blue-50 to-white rounded-xl mb-4">
                                                        <span class="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 shadow-md">
                                                            问
                                                        </span>
                                                        <div class="pt-1">{{ item.q }}</div>
                                                    </div>
                                                    <div class="text-gray-700 px-6 p-3 flex items-start gap-4 bg-gradient-to-r from-green-50 to-white rounded-xl">
                                                        <span class="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 shadow-md">
                                                            答
                                                        </span>
                                                        <div class="pt-1">{{ item.a }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-full flex-shrink-0 ">
                                    <div class="mt-2  p-2  justify-center   " v-if="shouldShowSummaryPrompt">
                                        <div class="text-lg  text-gray-600">
                                            <span class="block font-bold">AI来访训练尚未结束！ </span>
                                            <span class="block"> 请点击<b>生成总结</b></span>
                                        </div>
                                        <div class=" pt-4"><el-button type="primary" @click="genSummary">生成总结</el-button></div>
                                    </div>
                                    <div class="mt-2" v-else>
                                        <div class="text-lg font-bold text-gray-600" v-html="renderedSummaryContent"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="isSmallScreen" class="mobile-main-content">
                <!-- 顶部标题栏 -->
                <div class="mobile-header">
                    <h1 class="text-2xl font-bold">{{curCharacter && curCharacter.name}}</h1>
                    <div class="flex gap-2 mt-2">
                        <template v-if="curCharacter && curCharacter.key_words">
                            <span v-for="(word, index) in curCharacter.key_words.split(',')"
                                  :key="index"
                                  class="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm">
                                <i class="fas fa-tag text-xs mr-1"></i>
                                {{word.trim()}}
                            </span>
                        </template>
                    </div>
                </div>

                <!-- 时间信息卡片 -->
                <div class="mobile-info-card">
                    <div class="info-item">
                        <div class="info-icon bg-blue-50">
                            <i class="fas fa-clock text-blue-500"></i>
                        </div>
                        <div class="info-text">
                            <span class="text-gray-500">AI来访时间：</span>
                            <span class="font-bold">{{trainInfo.startTime}}</span>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="info-icon bg-green-50">
                            <i class="fas fa-file-alt text-green-500"></i>
                        </div>
                        <div class="info-text">
                            <span class="text-gray-500">总结生成时间：</span>
                            <span class="font-bold">{{trainInfo.summaryTime?trainInfo.summaryTime:"待生成"}}</span>
                        </div>
                    </div>
                </div>

                <!-- 背景信息卡片 -->
                <div class="mobile-background-card">
                    <div class="card-header">
                        <i class="fas fa-info-circle text-blue-500"></i>
                        <span class="font-bold">背景信息</span>
                    </div>
                    <div class="card-content">
                        {{curCharacter && curCharacter.description ? curCharacter.description:""}}
                    </div>
                </div>

                <!-- 标签切换区 -->
                <div class="mobile-tab-switcher">
                    <div class="tab-buttons">
                        <button class="tab-button"
                                :class="{'active': pageSelect === 0}"
                                @click="setActiveTab(0)">
                            <i class="far fa-file-alt"></i>
                            <span>训练记录</span>
                        </button>
                        <button class="tab-button"
                                :class="{'active': pageSelect === 1}"
                                @click="setActiveTab(1)">
                            <i class="fas fa-newspaper"></i>
                            <span>总结</span>
                        </button>
                    </div>
                </div>

                <!-- 内容区 -->
                <div class="mobile-content-area">
                    <div v-if="pageSelect === 0" class="qa-list">
                        <div class="section-title">
                            <span>训练问答详情</span>
                            <button @click="ContinueTalk" class="continue-button">
                                <i class="fas fa-comments"></i>
                                <span>继续对话</span>
                            </button>
                        </div>

                        <div v-for="(item, index) in QALlist" :key="index" class="qa-item">
                            <div class="qa-index">{{ index + 1 }}</div>

                            <div class="question">
                                <span class="badge">问</span>
                                <div>{{ item.q }}</div>
                            </div>

                            <div class="answer">
                                <span class="badge">答</span>
                                <div>{{ item.a }}</div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="summary-area">
                        <div v-if="shouldShowSummaryPrompt" class="summary-prompt">
                            <div class="prompt-text">
                                <span>AI来访训练尚未结束！</span>
                                <span>请点击<b>生成总结</b></span>
                            </div>
                            <button @click="genSummary" class="generate-button">生成总结</button>
                        </div>
                        <div v-else class="summary-content" v-html="renderedSummaryContent"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LoginModule from './LoginModule.vue';
    import hljs from 'highlight.js'
    import axios from 'axios';
    import { mapState } from 'vuex'
    import MarkdownIt from 'markdown-it'

    import CommonHeader from './subassembly/CommonHeader.vue';
    /*import { jwtDecode } from 'jwt-decode';*/
export default {

    components: {
        LoginModule,
        CommonHeader,
        },
        metaInfo: {
            title: '识心智能 - 训练',
            meta: [
                {
                    name: 'description',
                    content: '识心智能官网，各行各业量身定制专属的智能心理健康解决方案，以AI科技的力量促进心理健康事业的创新与繁荣发展'
                },
                {
                    name: 'keywords',
                    content: '识心智能, 心理健康, 心理健康AI, 心理AI, 健康AI, 心理健康方案'
                }
            ]
        },
    data() {
        return {
            curUserId:"",
            QALlist: [
               /* {
                    q: "即使在不熟悉的社交场合里我仍然感到放松。",
                    a: "A.是"
                },    */
            ],
            pageSelect: 0,
            trainInfo: {
                summaryid: null,
                summaryTime:null,
                summary_path:null,
                tipInfo:null,
                startTime:null,
                characterId:null,
                id:null,
                trainType:null,
                conversation_id: null,
                summary_contet: null,
            },
            curCharacter:null,
        }
    },
        methods: {
            convertMessagesToQA(messages) {
                return messages.reduce((acc, item, index, array) => {
                    if (item.type === "send" && array[index + 1]?.type === "answer") {
                        acc.push({
                            q: item.message,
                            a: array[index + 1].message
                        });
                    }
                    return acc;
                }, []);
            },
            async getConversationInfo(conversation_id, user) {
                console.log("this.curCharacter")
                console.log(this.curCharacter)
                const headers = {
                    "Authorization": `Bearer ${this.curCharacter.api_key}`
                };
                const baseUrl = "/xing-api/v1/messages";
                let allMessages = [];

                // 内部递归函数处理分页
                const fetchMessages = async (cursor = null) => {
                    const params = {
                        "user": user || "abc-123",
                        "conversation_id": conversation_id,
                        "limit": "40",
                        ...(cursor && { cursor: cursor }) // 只在有cursor时添加此参数
                    };

                    try {
                        const response = await axios.get(baseUrl, { headers, params });

                        if (response.status === 200) {
                            // 处理当前页的消息
                            const currentMessages = [];
                            for (const info of response.data.data) {
                                if (info.query) {
                                    currentMessages.push({ type: 'send', message: info.query });
                                }
                                if (info.answer) {
                                    currentMessages.push({ type: 'answer', message: info.answer });
                                }
                            }

                            allMessages = [...allMessages, ...currentMessages];
                            if (response.data.has_more) {
                                await fetchMessages();
                            }
                        }
                    } catch (error) {
                        console.error('获取对话信息失败:', error);
                        throw error; // 向上传递错误
                    }
                };
                try {
                    // 开始获取所有消息
                    await fetchMessages();
                    if (allMessages.length > 0) {
                        this.contentList = allMessages;
                    }
                    return allMessages; // 返回所有消息
                } catch (error) {
                    console.error('处理对话信息失败:', error);
                    this.$message({
                        message: '获取对话历史失败,请稍后重试',
                        type: 'error'
                    });
                }
            },
            getQAInfo() {
                /*getConversationInfo
                QALlist*/
            },
            setActiveTab(tab) {
                if (this.pageSelect == tab) {
                    return;
                }
                this.pageSelect = tab;
            },
            handleLogin() { },
            timestamp2YY(timestamp) {
                const date = new Date(timestamp*1000);
                const year = String(date.getFullYear()).slice(-2);
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            },
            convertHistory() {
                if (!this.QALlist || !Array.isArray(this.QALlist)) {
                    return '';
                }

                return this.QALlist.map(item => {
                    return `query: ${item.q}\nanswer: ${item.a}`;
                }).join('\n');
            },
            async genSummary() {
                const token = localStorage.getItem('token')
                if (!token) {
                    return
                }

                if (this.isSending) {
                    return false;
                }
                this.isSending = true;
                try {
                    const history = this.convertHistory();

                    const requestData = {
                        summary_id: this.curCharacter.client_ID,
                        history: history,
                        conversation_id: this.trainInfo.conversation_id,
                        baseurl: this.curCharacter.baseurl,
                        client_ID: this.curCharacter.client_ID,
                        api_key: this.curCharacter.api_key,
                    };
                    this.$message({
                        message: '总结生成需要1-2分钟，请稍后查看。',
                        type: 'success'
                    });
                    const response = await axios({
                        method: 'post',
                        timeout: 160 * 1000,
                        url: '/api/train/make_summary',
                        headers: {
                            'accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        data: requestData
                    });

                    if (response.status === 200) {
                        console.log('Summary created successfully:', response.data);
                        if (response.data.summary) {
                            this.$message({
                                message: '对话总结已生成，请查看。',
                                type: 'success'
                            });
                            this.trainInfo.summary_contet = response.data.summary;
                            return true;
                        }
                    } else {
                        this.$message({
                            message: '生成总结失败，请稍后重试.',
                            type: 'error'
                        });
                        return false;
                    }
                } catch (error) {
                    console.error('Failed to create summary:', error);
                    this.$message({
                        message: '生成总结失败，请稍后重试',
                        type: 'error'
                    });
                    return false;
                } finally {
                    this.isSending = false;
                }
            },   
        ContinueTalk() {
            if (this.curCharacter) {
                const vjsonStr = JSON.stringify(this.curCharacter);
                localStorage.setItem('character', vjsonStr);
            }
            localStorage.setItem('continue', JSON.stringify({ conversation_id: this.trainInfo.conversation_id, userid:this.trainInfo.userid }));
            this.$router.push({ name: 'ChatTrain' });
        },
        async getSummaryInfo() {
            const token = localStorage.getItem('token')
            if (!token) {
                return
            }
            try {
                const payload = {
                    conversationList: [this.trainInfo.conversation_id],
                };
                const response = await axios.post('/api/train/getSummary', payload, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })

                if (response.data.code === '00') {
                    const info0 = response.data.info[0];
                    console.log("xxxxxxxx1");
                    this.trainInfo.summaryTime = info0.summaryTime?"20" + this.timestamp2YY(info0.summaryTime) :"";
                    this.trainInfo.summary_path = info0.summary_path;
                    this.trainInfo.tipInfo = info0.tipInfo;
                    this.trainInfo.startTime = "20" + this.timestamp2YY(info0.startTime/1000);
                    this.trainInfo.characterId = info0.characterId;
                    this.trainInfo.id = info0.id;
                    this.trainInfo.client_id = info0.client_id;
                    this.trainInfo.trainType = info0.trainType;
                    this.trainInfo.conversation_id = info0.conversation_id;
                    if (response.data.summary_contet) {
                        this.trainInfo.summary_contet = JSON.parse(response.data.summary_contet).summary;
                    }
                    
                    if (this.globalCharacters && this.trainInfo.characterId) {
                        this.curCharacter = this.globalCharacters.find(
                            char => char.id === this.trainInfo.characterId
                        )
                        const messages = await this.getConversationInfo(this.trainInfo.conversation_id, this.trainInfo.userid);
                        if (!Array.isArray(messages)) {
                            console.warn('返回的消息格式不正确');
                            return;
                        }
                        this.QALlist = this.convertMessagesToQA(messages);
                    }
                }
            } catch (error) {
                console.error('获取角色列表失败:', error)
            }
            return;
        }
    },
        created() {
            this.md = new MarkdownIt({
                html: true,
                linkify: true,
                typographer: true,
                breaks: true,
                highlight: function (str, lang) {
                    if (lang && hljs.getLanguage(lang)) {
                        try {
                            return hljs.highlight(str, { language: lang }).value;
                        } catch (__) {console.log("!")}
                    }
                    return ''; // 使用默认的转义
                }
            });
            var params = localStorage.getItem("router");
            if (!params) {
                return;
            }
            var paramsObj = JSON.parse(atob(params));
            this.trainInfo.conversation_id = paramsObj.id;
            this.trainInfo.userid = paramsObj.userid;
            this.getSummaryInfo();
    },
    computed: {
        shouldShowSummaryPrompt() {
            return !this.trainInfo?.summary_contet;
        },
        ...mapState({
            globalCharacters: state => state.globalCharacters
        }),
        renderedSummaryPrompt() {
            if (!this.curCharacter || !this.curCharacter.summary_prompt) {
                return '';
            }
            return this.md.render(this.curCharacter.summary_prompt);
        },
        renderedSummaryContent() {
            if (!this.trainInfo?.summary_contet) return '';
            return this.md.render(this.trainInfo.summary_contet);
        }
        },
   
}
</script>

<style >
    @import url('https: //cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');

    /* 移动端样式 */
    .mobile-main-content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .mobile-header {
        padding: 8px 0;
    }

    .mobile-info-card {
        background: white;
        border-radius: 12px;
        padding: 12px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }

    .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
    }

    .info-icon {
        padding: 6px;
        border-radius: 8px;
        margin-right: 12px;
    }

    .info-text {
        font-size: 14px;
    }

    .mobile-background-card {
        background: linear-gradient(to bottom right, #ebf5ff, #f7fbff);
        border-radius: 12px;
        padding: 16px;
        border: 1px solid #dbeafe;
    }

    .card-header {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        font-size: 16px;
    }

        .card-header i {
            margin-right: 8px;
            font-size: 18px;
        }

    .card-content {
        background: rgba(255,255,255,0.8);
        padding: 12px;
        border-radius: 8px;
        font-size: 14px;
        line-height: 1.5;
    }

    .mobile-tab-switcher {
        margin-top: 8px;
    }

    .tab-buttons {
        display: flex;
        background: #e5e7eb;
        border-radius: 12px;
        padding: 4px;
    }

    .tab-button {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        border-radius: 8px;
        font-size: 14px;
        background: transparent;
        border: none;
    }

        .tab-button.active {
            background: white;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .tab-button i {
            margin-right: 6px;
        }

    .mobile-content-area {
        margin-top: 8px;
    }

    .section-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: bold;
    }

    .continue-button {
        background: linear-gradient(to right, #f6e05e, #ed8936);
        color: white;
        border: none;
        border-radius: 8px;
        padding: 8px 12px;
        font-size: 14px;
        display: flex;
        align-items: center;
    }

        .continue-button i {
            margin-right: 6px;
        }

    .qa-item {
        background: #f9fafb;
        border-radius: 12px;
        padding: 12px;
        margin-bottom: 16px;
    }

    .qa-index {
        font-weight: bold;
        color: #3b82f6;
        margin-bottom: 8px;
        font-size: 16px;
    }

    .question, .answer {
        display: flex;
        gap: 8px;
        padding: 12px;
        margin-bottom: 8px;
        border-radius: 8px;
    }

    .question {
        background: linear-gradient(to right, #ebf4ff, #ffffff);
    }

    .answer {
        background: linear-gradient(to right, #f0fdf4, #ffffff);
    }

    .badge {
        background: #3b82f6;
        color: white;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        font-size: 12px;
    }

    .answer .badge {
        background: #10b981;
    }

    .summary-prompt {
        text-align: center;
        padding: 24px;
        font-size: 16px;
    }

    .generate-button {
        background: #3b82f6;
        color: white;
        border: none;
        border-radius: 8px;
        padding: 12px 24px;
        margin-top: 16px;
        font-size: 16px;
    }

    .summary-content {
        font-size: 15px;
        line-height: 1.6;
        padding: 8px;
    }
</style>

